<script>
import { Line } from "vue-chartjs";
const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "bottom",
  },
  layout: {
    padding: -5
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          stepSize: 20
        },
      },
    ],
  },
};
export default {
  extends: Line,

  props: ["chartData", "options"],

  mounted() { },
  watch: {
    chartData: {
      handler(n, o) {
        this.renderChart(n, options);
      },
      deep: true,
    },
  },
  methods: {},
};
</script>